angular.module("digitalLeasing.module").component("additionalImmoInfo", {
    templateUrl: "ng/components/digitalLeasing/financialLeasingRequest/additionalImmoInfo/additionalImmoInfo.view.html",
    bindings: {
        model: "=", //beneContratto
        customer: "=",
        immobiliare: "=",
        addImmoIsOk: "&",
        addImmoIsNotOk: "&",
        viewIndex: "=",
        initialTabIndex: "=",
        completatoArc: "="
    },
    controllerAs: "additionalImmoInfoCtrl",
    controller: AdditionalImmoInfoController
});

function AdditionalImmoInfoController(
    $rootScope,
    $typeDomainService,
    GeneralIdDescription,
    Sede,
    Residenza,
    $financialApiService,
    $giuridicVersion
) {
    var initProvince = function () {
        self.supportModel.dropdown.province = $rootScope.comuniMap
            .map(function (comune) {
                return comune.sigla;
            })
            .filter(function (siglaComune) {
                return siglaComune != "";
            })
            .sort()
            .reduce(function (result, nextItem) {
                return result.includes(nextItem) ? result : result.concat(nextItem);
            }, []);
    };
    var self = this;

    self.$onInit = function () {
        self.supportModel = {
            dropdown: {
                immoType: [],
                immoState: [],
                province: [],
                comuni: [],
                caps: [],
                destinationUse: [],
                propertyType: [],
                endSearchRest: false,
            },
            options: ["AZIENDA", "PERSONA"],
            defaultOptions: "AZIENDA",
            indProprietarioImm: "",
            proprietarioAttuale: "",
            isM12: true,
            residenza: false,
            sedeIsPresent: false,
            immobiliareType: "IMM",
            isEditable: false,
            addressList: [],
            showSedeComponent: false,
            sedeConsegnaSelected: [],
            initialAddress: "",
            immoTypeSelected: [],
            statoSelected: [],
            typeSelected: [],
            utilizzoSelected: [],
            initialIndex: 0
        };

        self.supportModel.initialIndex = self.initialTabIndex || 0;

        if (getWizardMap(self.viewIndex) == "M15") {
            self.supportModel.isM12 = false;
            self.supportModel.isEditable = false;
        } else {
            self.supportModel.isEditable = true;
        }

        if (!self.model.immobiliare.stato) {
            self.model.immobiliare.stato = "LBL_FREE_IMM";
        }

        if (!self.model.immobiliare.proprietarioImmobile.isPersona) {
            //popola il componente sede
            self.supportModel.proprietarioAttuale = self.model.immobiliare.proprietarioImmobile.riUserG.sedeLegale ?
                self.model.immobiliare.proprietarioImmobile.riUserG.sedeLegale : self.customer.metadata.riUserG.sedeLegale;

            //popola il componente customerDigital  
            self.supportModel.initialAddress = self.model.immobiliare.proprietarioImmobile.riUserG.sedeLegale ?
                self.model.immobiliare.proprietarioImmobile : null;

            if (self.supportModel.initialAddress &&
                $giuridicVersion.checkIfInd(self.supportModel.initialAddress.riUserG.formaGiuridica)) {
                self.supportModel.initialAddress.riUserF = null;
            }
        } else {
            //popola il componente sede
            self.supportModel.proprietarioAttuale = self.model.immobiliare.proprietarioImmobile.riUserF.residenza ?
                self.model.immobiliare.proprietarioImmobile.riUserF.residenza : self.customer.metadata.riUserF.residenza;

            //popola il componente customerDigital  
            self.supportModel.initialAddress = self.model.immobiliare.proprietarioImmobile.riUserF.residenza ?
                self.model.immobiliare.proprietarioImmobile : null;
        }

        initProvince();
        getImmoType();
        getImmoState();
        getDestinationUse();
        getPropertyType();
        selectAddress();
        checkValidation();
    };

    //onChange sulle province
    self.getCaps = function (comune) {
        var found = comune.cap;

        self.supportModel.dropdown.caps = found || [];
    };

    self.getComuni = function (provincia) {
        self.supportModel.dropdown.comuni = $rootScope.comuniMap
            .filter(function (comune) {
                return comune.sigla == provincia;
            });
    };

    self.handleChange = function (property, value) {
        if (self.model.immobiliare) {
            switch (property) {
                case "tipo":
                case "utilizzo":
                    self.model.immobiliare[property] = GeneralIdDescription.build({
                        id: value.value,
                        description: value.description
                    });
                    break;
                case "sedeLegale":
                    self.model.immobiliare.proprietarioImmobile.riUserG[property] = value;
                    break;
                case "residenza":
                    self.model.immobiliare.proprietarioImmobile.riUserF[property] = value;
                    break;
                case "impiantoFotovoltaico":
                    self.model.immobiliare[property] = value;
                    if (!self.model.impiantoFotovoltaico) {
                        self.model.proprietarioFotovoltaico = "";
                        self.model.titoloGiuridico = "";
                    }
                    break;
                case "stato":
                case "tipoImmobile":
                    self.model.immobiliare[property] = value.description;
                    break;
                case "sedeConsegna":
                    self.supportModel.showSedeComponent = value.toponomastica === "NUOVO INDIRIZZO" ? true : false;

                    populateSedeConsegna(value);
                    break;
                case "indirizzoImmobile":
                    self.model.immobiliare.indirizzoImmobile = value;
                    self.model.immobiliare.indirizzoImmobile.isNewAddress = self.supportModel.showSedeComponent;
                    self.model.immobiliare.indirizzoImmobile.comune = value.comune && value.comune.nome ? value.comune.nome : value.comune;

                    if (!self.model.immobiliare.indirizzoImmobile.cdTipoIndirizzo) {
                        self.model.immobiliare.indirizzoImmobile.cdTipoIndirizzo = "INS";
                    }
                    if (self.model.immobiliare.indirizzoImmobile.isNewAddress) {
                        self.model.immobiliare.indirizzoImmobile.toponomastica = null;
                    }
                    break;
                case "cfPiva":
                case "ragSocNominativo":
                    self.model.immobiliare.proprietarioImmobile[property] = value;
                    break;
                default:
                    self.model.immobiliare[property] = value;
                    break;
            }
        }

        checkValidation();

    }

    self.exportValidityCustomerDigital = function (validity) {
        self.validityCustomerDigital = validity;
        if (!validity && !self.supportModel.sedeIsPresent) {
            if (self.model.immobiliare.proprietarioImmobile.riUserG &&
                self.model.immobiliare.proprietarioImmobile.riUserG.sedeLegale) {
                self.model.immobiliare.proprietarioImmobile.riUserG.sedeLegale = null;
                self.model.immobiliare.proprietarioImmobile.riUserG.sedeLegale = Sede.build();
                self.supportModel.proprietarioAttuale = Sede.build();
            } else if (self.model.immobiliare.proprietarioImmobile.riUserF &&
                self.model.immobiliare.proprietarioImmobile.riUserF.residenza) {
                self.model.immobiliare.proprietarioImmobile.riUserF.residenza = null;
                self.model.immobiliare.proprietarioImmobile.riUserF.residenza = Residenza.build();
                self.supportModel.proprietarioAttuale = Residenza.build();
            }
        }

        checkValidation();
    }

    self.getSubject = function (value) {
        self.supportModel.endSearchRest = !self.supportModel.endSearchRest;
        if (value && value.riUserG) {
            self.supportModel.residenza = false;
            self.model.immobiliare.proprietarioImmobile.isPersona = false;
            self.model.immobiliare.proprietarioImmobile.riUserG = value.riUserG;
            self.supportModel.proprietarioAttuale = value.riUserG.sedeLegale;

            self.model.immobiliare.proprietarioImmobile.riUserF = {};

        } else if (value && value.riUserF) {
            self.supportModel.residenza = true;
            self.model.immobiliare.proprietarioImmobile.isPersona = true;
            self.model.immobiliare.proprietarioImmobile.riUserF = value.riUserF;
            self.supportModel.proprietarioAttuale = value.riUserF.residenza;

            self.model.immobiliare.proprietarioImmobile.riUserG = {};
        }
        checkValidation();
    }

    self.checkSede = function (isPresent) {
        self.supportModel.sedeIsPresent = isPresent;
    }

    var checkValidation = function () {
        self.supportModel.endSearchRest = !self.supportModel.endSearchRest;
        var test = false;
        var testFotovoltaico = false;
        var indirizzi = false;
        var destinazioneUso = false;
        var customerDigital = false;

        if (self.model.immobiliare.impiantoFotovoltaico) {
            testFotovoltaico = self.model.immobiliare.proprietarioFotovoltaico &&
                self.model.immobiliare.titoloGiuridico
        } else {
            testFotovoltaico = true;
        }

        if (self.supportModel.isM12) {
            if (self.model.immobiliare) {
                test = !!self.model.immobiliare.indirizzoImmobile &&
                    !!self.model.immobiliare.tipo &&
                    !!self.model.immobiliare.utilizzo &&
                    self.model.immobiliare.stato && self.model.immobiliare.tipoImmobile;
            }

            indirizzi = checkProductType();
            destinazioneUso = self.model.immobiliare.destinazioneUso;
            customerDigital = true;

        } else {
            if (self.completatoArc) {
                test = !!self.model.immobiliare.tipo && !!self.model.immobiliare.utilizzo;
                destinazioneUso = self.model.immobiliare.destinazioneUso;
                indirizzi = true;
                customerDigital = true;
                self.model.immobiliare.clienteProprietarioImm = true;

            } else {
                test = !!self.model.immobiliare.tipo && !!self.model.immobiliare.utilizzo &&
                    self.model.immobiliare.stato && self.model.immobiliare.tipoImmobile;
                destinazioneUso = self.supportModel.isM12 ? self.model.immobiliare.destinazioneUso : true;
                indirizzi = self.model.immobiliare.indirizzoImmobile.stato &&
                    self.model.immobiliare.indirizzoImmobile.stato.name &&
                    self.model.immobiliare.indirizzoImmobile.indirizzo &&
                    self.model.immobiliare.indirizzoImmobile.provincia &&
                    self.model.immobiliare.indirizzoImmobile.comune &&
                    self.model.immobiliare.indirizzoImmobile.numeroCivico;
                customerDigital = true;

                //MANTIS 0015898: se financialModel.leasingData.preventivo.completatoArc è false 
                //e sei in M15 --> forzo il flag clienteProprietarioImm a true 
                self.model.immobiliare.clienteProprietarioImm = true;
            }
        }

        if (test && testFotovoltaico && indirizzi && destinazioneUso && customerDigital) {
            self.addImmoIsOk();
        } else {
            self.addImmoIsNotOk();
        }
    }

    var checkProductType = function () {
        if (self.supportModel.isM12) {
            if (self.model.immobiliare.indirizzoImmobile.stato &&
                self.model.immobiliare.indirizzoImmobile.stato.name &&
                self.model.immobiliare.indirizzoImmobile.indirizzo &&
                self.model.immobiliare.indirizzoImmobile.provincia &&
                self.model.immobiliare.indirizzoImmobile.comune &&
                self.model.immobiliare.indirizzoImmobile.numeroCivico) {
                return true;
            } else {
                return false;
            }
        } else {
            if (self.model.immobiliare.proprietarioImmobile.isPersona) {
                if (self.model.immobiliare.proprietarioImmobile.riUserF &&
                    self.model.immobiliare.proprietarioImmobile.riUserF.residenza &&
                    self.model.immobiliare.proprietarioImmobile.riUserF.residenza.stato &&
                    self.model.immobiliare.proprietarioImmobile.riUserF.residenza.stato.name &&
                    self.model.immobiliare.proprietarioImmobile.riUserF.residenza.indirizzo &&
                    self.model.immobiliare.proprietarioImmobile.riUserF.residenza.provincia &&
                    self.model.immobiliare.proprietarioImmobile.riUserF.residenza.comune &&
                    self.model.immobiliare.proprietarioImmobile.riUserF.residenza.numeroCivico &&

                    self.model.immobiliare.indirizzoImmobile.stato &&
                    self.model.immobiliare.indirizzoImmobile.stato.name &&
                    self.model.immobiliare.indirizzoImmobile.indirizzo &&
                    self.model.immobiliare.indirizzoImmobile.provincia &&
                    self.model.immobiliare.indirizzoImmobile.comune &&
                    self.model.immobiliare.indirizzoImmobile.numeroCivico) {
                    return true;
                } else {
                    return false;
                }
            } else {
                if (self.model.immobiliare.proprietarioImmobile.riUserG &&
                    self.model.immobiliare.proprietarioImmobile.riUserG.sedeLegale &&
                    self.model.immobiliare.proprietarioImmobile.riUserG.sedeLegale.stato &&
                    self.model.immobiliare.proprietarioImmobile.riUserG.sedeLegale.stato.name &&
                    self.model.immobiliare.proprietarioImmobile.riUserG.sedeLegale.indirizzo &&
                    self.model.immobiliare.proprietarioImmobile.riUserG.sedeLegale.provincia &&
                    self.model.immobiliare.proprietarioImmobile.riUserG.sedeLegale.comune &&
                    self.model.immobiliare.proprietarioImmobile.riUserG.sedeLegale.numeroCivico &&

                    self.model.immobiliare.indirizzoImmobile.stato &&
                    self.model.immobiliare.indirizzoImmobile.stato.name &&
                    self.model.immobiliare.indirizzoImmobile.indirizzo &&
                    self.model.immobiliare.indirizzoImmobile.provincia &&
                    self.model.immobiliare.indirizzoImmobile.comune &&
                    self.model.immobiliare.indirizzoImmobile.numeroCivico) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    }

    var getImmoType = function () {
        $typeDomainService.getDomainSet("ADDITIONAL_IMMO_INFO", "BUILDING_TYPE").then(function (response) {
            self.supportModel.dropdown.immoType = response.domainList;

            if (!self.model.immobiliare.tipoImmobile) {
                self.supportModel.immoTypeSelected = response.domainList[0];
                self.model.immobiliare.tipoImmobile = self.supportModel.immoTypeSelected.description;
            } else {
                response.domainList.forEach(function (element) {
                    if (element.description === self.model.immobiliare.tipoImmobile) {
                        self.supportModel.immoTypeSelected = element;
                    }
                });
            }
        });
    };

    var getImmoState = function () {
        $typeDomainService.getDomainSet("ADDITIONAL_IMMO_INFO", "BUILDING_STATUS").then(function (response) {
            self.supportModel.dropdown.immoState = response.domainList;

            if (!self.model.immobiliare.stato || self.model.immobiliare.stato === "LBL_FREE_IMM") {
                self.supportModel.statoSelected = response.domainList[0];
                self.model.immobiliare.stato = self.supportModel.statoSelected.description;
            } else {
                for (var i = 0; i < response.domainList.length; i++) {
                    if (self.model.immobiliare.stato === response.domainList[i].name) {
                        self.supportModel.statoSelected = response.domainList[i];
                        break;
                    }
                }
            }
        });
    };

    var getDestinationUse = function () {
        $typeDomainService.getDomainSet("ADDITIONAL_INFO_ASSET", "INTENDED_USE").then(function (response) {
            self.supportModel.dropdown.destinationUse = response.domainList;

            if (!self.model.immobiliare.utilizzo.description) {
                self.supportModel.utilizzoSelected = response.domainList[0];

                self.model.immobiliare.utilizzo = GeneralIdDescription.build({
                    id: self.supportModel.utilizzoSelected.value,
                    description: self.supportModel.utilizzoSelected.description
                });
            } else {
                self.supportModel.utilizzoSelected = self.model.immobiliare.utilizzo;
            }
        });
    };

    var getPropertyType = function () {
        $typeDomainService.getDomainSet("ADDITIONAL_INFO_ASSET", "TYPE_OF_PROPERTY").then(function (response) {
            self.supportModel.dropdown.propertyType = response.domainList;

            if (!self.model.immobiliare.tipo.description) {
                self.supportModel.typeSelected = response.domainList[0];

                self.model.immobiliare.tipo = GeneralIdDescription.build({
                    id: self.supportModel.typeSelected.value,
                    description: self.supportModel.typeSelected.description
                });
            } else {
                self.supportModel.typeSelected = self.model.immobiliare.tipo;
            }
        });
    };

    var getWizardMap = function (viewIndex) {
        return $rootScope.wizardMap
            .find(function (element) {
                return element.index == viewIndex
            }).viewName
    }

    var selectAddress = function () {
        if (self.model.immobiliare.indirizzoImmobile.indirizzo) {
            self.supportModel.sedeConsegnaSelected = self.model.immobiliare.indirizzoImmobile;

            if (self.model.immobiliare.indirizzoImmobile.isNewAddress) {
                self.supportModel.showSedeComponent = true;
                self.model.immobiliare.indirizzoImmobile.toponomastica = "NUOVO INDIRIZZO";
            }
        }

        $financialApiService
            .searchAddress(self.customer.metadata.riUserG.ndg)
            .then(function (addressResponse) {
                self.supportModel.addressList = addressResponse.nsilAddresses;
                self.supportModel.addressList.push({
                    toponomastica: "NUOVO INDIRIZZO"
                });

                if (!self.supportModel.sedeConsegnaSelected.cdTipoIndirizzo) {
                    self.supportModel.addressList.forEach(function (addressSelected) {
                        if (addressSelected.cdTipoIndirizzo === "LEG") {
                            self.supportModel.sedeConsegnaSelected = addressSelected;
                        }
                    });
                }

                populateSedeConsegna(self.supportModel.sedeConsegnaSelected);

            }).catch(function (error) {
                console.error(error);
            });
    }

    var populateSedeConsegna = function (value) {
        self.model.immobiliare.indirizzoImmobile = Sede.build(value);
        self.model.immobiliare.indirizzoImmobile.luogoEsteso.nome = value.comune;
        self.model.immobiliare.indirizzoImmobile.luogoEsteso.sigla = value.provincia;
        self.model.immobiliare.indirizzoImmobile.luogoEsteso.cap[0] = value.cap;

        if (!self.model.immobiliare.indirizzoImmobile.cdTipoIndirizzo) {
            self.model.immobiliare.indirizzoImmobile.cdTipoIndirizzo = "LEG";
        }

        if (self.model.immobiliare.indirizzoImmobile.isNewAddress) {
            self.model.immobiliare.indirizzoImmobile.toponomastica = null;
        }

        checkValidation();
    }
}